/**
 * Ortak format yardımcıları — TR yerel ayarları ile.
 */

export function formatDate(dateStr, opts = {}) {
  if (!dateStr) return '—';
  try {
    const d = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    if (isNaN(d.getTime())) return '—';
    const defaults = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Intl.DateTimeFormat('tr-TR', { ...defaults, ...opts }).format(d);
  } catch {
    return String(dateStr);
  }
}

export function formatDateTime(dateStr) {
  return formatDate(dateStr, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(value, opts = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat('tr-TR', opts).format(value);
}

export function formatCurrency(value, currency = 'TRY') {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value);
}

/** ASPara — "15.000" gibi, sembolsüz */
export function formatASPara(value) {
  if (value === null || value === undefined) return '—';
  return `${formatNumber(value)}`;
}

/** "15K / 10K / 5K" şeklinde rewards özeti */
export function formatRewardsShort(rewards) {
  if (!Array.isArray(rewards) || rewards.length === 0) return '—';
  return rewards
    .slice(0, 3)
    .map((r) => {
      const k = Math.round((r.amount || 0) / 1000);
      return k >= 1 ? `${k}K` : String(r.amount);
    })
    .join('/');
}

/** Yüzde — 0-100 arası */
export function formatPercent(value, decimals = 0) {
  if (value === null || value === undefined) return '—';
  return `${Number(value).toFixed(decimals)}%`;
}

/** Son N karaktere kadar kısalt (KVKK maskeleme) — örn: "AH***N Y." */
export function maskName(fullName) {
  if (!fullName) return '—';
  const parts = fullName.trim().split(/\s+/);
  const mask = (w) => {
    if (w.length <= 2) return w.toUpperCase();
    return `${w.slice(0, 2).toUpperCase()}***${w.slice(-1).toUpperCase()}`;
  };
  return parts.map((p, i) => (i < parts.length - 1 ? mask(p) : `${p[0].toUpperCase()}.`)).join(' ');
}
